import Toaster from "@/components/toaster";
import Protected from "@/pages/protected";
import { DataService } from "@/services/data";
import { Outlet, RouteObject, defer, redirect } from "react-router-dom";

const MergerRoute: RouteObject = {
    path: "fusion",
    element: (
        <Protected groups={["app_tools_admin", "team_support", "team_csm"]}>
            <Outlet />
        </Protected>
    ),
    children: [
        {
            index: true,
            async lazy() {
                let { MergerSearchPage } = await import("@/pages/tools/merger/search");
                return { Component: MergerSearchPage };
            },
        },
        {
            path: ":value_from/:value_into",
            async lazy() {
                let { MergerCommitPage } = await import("@/pages/tools/merger/commit");
                return { Component: MergerCommitPage };
            },
            loader: async ({ params }) => {
                const value_from = decodeURIComponent(params.value_from || "");
                const value_into = decodeURIComponent(params.value_into || "");
                const professions = await DataService.client.url(`/tools/merger/professions/`).get().json();
                const merger_data = DataService.client.url(`/tools/merger/search/`).post({ value_from: value_from, value_into: value_into }).json();
                return defer({ professions, merger_data });
            },
            action: async ({ request }) => {
                const data = await request.json();
                try {
                    await DataService.client.url(`/tools/merger/`).post(data).json();
                    return redirect(`/outils/fusion/${encodeURIComponent(data.value_from)}/${encodeURIComponent(data.value_into)}/success`);
                } catch (e) {
                    console.error(e);
                    Toaster.error(`Une erreur est survenue`);
                    return {};
                }
            }
        },
        {
            path: ":value_from/:value_into/success",
            async lazy() {
                let { MergerSuccessPage } = await import("@/pages/tools/merger/success");
                return { Component: MergerSuccessPage };
            },
        }
    ]
};
export default MergerRoute;
